import React, { Suspense } from "react";
import { Form, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { Await, useRouteLoaderData } from "react-router-dom";
import { formatDemographicText } from "../HelperFunctions";

export default function DemoPicker({
    formData,
    setFormData,
    name,
    disabled,
    filterFunction = () => true,
    multiple = false,
    limit = 4,
    label = "Demographic",
    formKey = "demo",
    stationKey = "station",
}) {
    const { demographics } = useRouteLoaderData("root");

    return (
        <Suspense fallback={<Fallback name={name} label={label} formKey={formKey} />}>
            <Await resolve={demographics}>
                {resolvedDemos => (
                    <Form.Group as={Col} className="col-12 col-xl-2 min-w-demo">
                        <Form.Label>{label}</Form.Label>
                        <Typeahead
                            id={`${name}-${formKey}-selection`}
                            options={resolvedDemos.data
                                .filter(x => (x.data_type === 1 && formData[stationKey][0]?.stream) || (x.data_type === 2 && formData[stationKey][0]?.ppm))
                                .filter(filterFunction)}
                            labelKey={x => formatDemographicText(x)}
                            highlightOnlyResult
                            placeholder="Select demographic..."
                            emptyLabel={formData.demo.length < limit ? "No demographics found." : "Demographics limit reached."}
                            clearButton={true}
                            multiple={multiple}
                            disabled={disabled || resolvedDemos.data.filter(filterFunction).length === 0}
                            onChange={value => (value.length <= limit ? setFormData({ ...formData, [formKey]: value }) : null)}
                            selected={formData[formKey]}
                        />
                    </Form.Group>
                )}
            </Await>
        </Suspense>
    );
}

function Fallback({ name, label, formKey }) {
    return (
        <Form.Group as={Col} className="col-12 col-xl-2 min-w-demo">
            <Form.Label>{label}</Form.Label>
            <Typeahead id={`${name}-${formKey}-selection-fallback`} options={[]} placeholder="Loading demographics..." disabled />
        </Form.Group>
    );
}
